import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TRefundsRequest,
	TRefundsResponsePayload,
	TRefundsStore,
	TRefundBreakdownRequest,
	TRefundBreakdownResponsePayload,
} from './types';

// ==========================================:
export const initialState: TRefundsStore = {
	refunds: null,
	refundsLoader: false,
	refundsForFilterId: null,
	refundsForFilterIdLoader: false,
	refund: null,
	refundLoader: false,
	refundBreakdown: null,
	refundBreakdownLoader: false,
};

// ==========================================:
const refunds = createSlice({
	name: '@@refunds',
	initialState,
	reducers: {
		getRefundsRequest: (state: TRefundsStore, action: PayloadAction<TRefundsRequest>) => {
			const refundsState = state;
			refundsState.refundsLoader = true;
		},
		getRefundsSuccess: (state: TRefundsStore, action: PayloadAction<TRefundsResponsePayload>) => {
			const { payload } = action;
			const refundsState = state;
			refundsState.refunds = payload;
			refundsState.refundsLoader = false;
		},
		getRefundsForFilterIdRequest: (
			state: TRefundsStore,
			action: PayloadAction<TRefundsRequest>,
		) => {
			const refundsState = state;
			refundsState.refundsForFilterIdLoader = true;
		},
		getRefundsForFilterIdSuccess: (
			state: TRefundsStore,
			action: PayloadAction<TRefundsResponsePayload>,
		) => {
			const { payload } = action;
			const refundsState = state;
			refundsState.refundsForFilterId = payload;
			refundsState.refundsForFilterIdLoader = false;
		},
		resetRefundsForFilterId: (state: TRefundsStore) => {
			const refundsState = state;
			refundsState.refundsForFilterId = null;
			refundsState.refundsForFilterIdLoader = false;
		},
		getRefundRequest: (state: TRefundsStore, action: PayloadAction<TRefundsRequest>) => {
			const refundsState = state;
			refundsState.refundLoader = true;
		},
		getRefundSuccess: (state: TRefundsStore, action: PayloadAction<TRefundsResponsePayload>) => {
			const { payload } = action;
			const refundsState = state;
			refundsState.refund = payload;
			refundsState.refundLoader = false;
		},
		getRefundBreakdownRequest: (
			state: TRefundsStore,
			action: PayloadAction<TRefundBreakdownRequest>,
		) => {
			const refundsState = state;
			refundsState.refundBreakdownLoader = true;
		},
		getRefundBreakdownSuccess: (
			state: TRefundsStore,
			action: PayloadAction<TRefundBreakdownResponsePayload>,
		) => {
			const { payload } = action;
			const refundsState = state;
			refundsState.refundBreakdown = payload;
			refundsState.refundBreakdownLoader = false;
		},
		resetRefundBreakdown: (state: TRefundsStore) => {
			const refundsState = state;
			refundsState.refundBreakdown = null;
			refundsState.refundBreakdownLoader = false;
		},
		refundsInitState: () => initialState,
	},
});

export default refunds.reducer;
export const {
	getRefundsRequest,
	getRefundsSuccess,
	getRefundsForFilterIdRequest,
	getRefundsForFilterIdSuccess,
	resetRefundsForFilterId,
	getRefundRequest,
	getRefundSuccess,
	getRefundBreakdownRequest,
	getRefundBreakdownSuccess,
	resetRefundBreakdown,
	refundsInitState,
} = refunds.actions;
